import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import useAddSeats from "api/SubscriptionsResource/useAddSeats";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { activePaymentMethods, activeCurrencies } from "utils";

const StarsPay = ({ subscriptionId, additionalSeats, totalAmount, onSuccess, currency }) => {
	const { mutateAsync: addSeats, isLoading } = useAddSeats(subscriptionId, onSuccess);

	// Convert to Stars points (example: $1 = 100 stars)
	const starsRequired = Math.ceil(totalAmount * 100);

	const formik = useFormik({
		initialValues: {
			student_number: "",
		},
		validationSchema: Yup.object({
			student_number: Yup.string().required("Student number is required"),
		}),
		onSubmit: async (values) => {
			await addSeats({
				additional_seats: additionalSeats,
				payment_method: activePaymentMethods.stars.name,
				currency: currency || activeCurrencies.ZWL.code,
				total_amount: totalAmount,
				student_number: values.student_number,
				points_used: starsRequired,
			});
		},
	});

	return (
		<form onSubmit={formik.handleSubmit} className="space-y-4">
			<div className="bg-yellow-50 border-l-4 border-yellow-500 p-4">
				<p className="text-yellow-700 text-sm">
					<strong>Stars Required:</strong> {starsRequired} stars for {additionalSeats} additional
					seat(s)
				</p>
				<p className="text-yellow-600 text-xs mt-1">Equivalent to ${totalAmount.toFixed(2)} USD</p>
			</div>

			<div>
				<label className="block text-sm font-medium text-gray-700 mb-2">Student Number</label>
				<input
					type="text"
					name="student_number"
					placeholder="Enter your student number"
					value={formik.values.student_number}
					onChange={formik.handleChange}
					onBlur={formik.handleBlur}
					className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-akgreen focus:border-transparent"
				/>
				{formik.errors.student_number && formik.touched.student_number && (
					<p className="mt-1 text-sm text-red-600">{formik.errors.student_number}</p>
				)}
			</div>

			<button
				type="submit"
				disabled={isLoading}
				className="w-full px-6 py-3 bg-gradient-to-r from-yellow-500 to-yellow-600 text-white font-semibold rounded-lg hover:shadow-lg transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
			>
				{isLoading ? (
					<>
						<AiOutlineLoading3Quarters className="animate-spin" size={20} />
						Processing...
					</>
				) : (
					"Pay with Stars"
				)}
			</button>
		</form>
	);
};

export default StarsPay;
